import { PublicClientApplication } from "@azure/msal-browser";
import { getAuthConfiguration } from "./authConfig";

export const msalInstance = new PublicClientApplication(getAuthConfiguration());